import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";

//styles
import { Container } from "../styles";
import { RecommendedEpisodes, EpisodeContainer } from "./styles";

import { sendMessageToUser } from '../../../common';

import { ACCESS_TOKEN,USER_ACCOUNT } from '../../../constants';

//component
import EpisodeCardComponent from "../../../components/EpisodeCardComponent";
import PlayerComponent from "../../../components/PlayerComponent";

import Comment from "../../../components/Comment";
//constants
import { Button } from "../../../elements/CTA";

import { graphql, Query } from 'react-apollo';
import { compose } from 'recompose';
import { EPISODE_QUERY, RECOMEND_EPISODE_QUERY } from '../../../services/graphql/query';
import { COMMENT_MUTATION } from '../../../services/graphql/mutations';

import Layout from "../../../hoc/Layout/Layout";


import moment from "moment";
import "moment/locale/pt-br";
import { Play3 } from "styled-icons/icomoon/";
import Textarea from "react-textarea-autosize";

const Account = localStorage.getItem(USER_ACCOUNT);
class Episode extends Component {
  constructor(props){
    super(props);
    this.state = {
       qtdComentarios: 0,
       comentario: '',
       comentarios: []
    }
}

static getDerivedStateFromProps(props, state) {
  let { data } = props;
  let new_state = state;
  if(!!data){
    if(!!data.episodes && !data.episodes.data[0].block_comments && data.episodes.data[0].comments && data.episodes.data[0].comments.data !== state.comentarios ) 
      new_state = { ...new_state, comentarios: data.episodes.data[0].comments.data }

    if(!!data.episodes && !data.episodes.data[0].block_comments && data.episodes.data[0].comments && data.episodes.data[0].comments.total !== state.qtdComentarios ) 
      new_state = { ...new_state, qtdComentarios: data.episodes.data[0].comments.total }

    if(!!data.episodes && data.episodes.data[0] !== state.episode ) 
      new_state = { ...new_state, episode: data.episodes.data[0] }
    if(!!data.recommendedEpisodes && data.recommendedEpisodes !== state.recommendedEpisodes )
      new_state = { ...new_state, recommendedEpisodes: data.recommendedEpisodes }

    if(data.loading !== state.loading ) 
      new_state = {...new_state, loading: data.loading }
  }
  // console.log('LocalStorage ', localStorage)
  
  return new_state;
}

  kFormatter(num) {
    return Math.abs(num) > 999
      ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
      : Math.sign(num) * Math.abs(num);
  }

  renderPlayCount(playCount){
    if(playCount){
      return (
        <>
          <Play3 className="play-icon" /> {this.kFormatter(playCount)}
        </>
      )
    } else{
      return <></>
      // return <>nenhum play ainda</>
    }
  }

  listTags = (tags) => {
    let arrTags = tags.split("#");
    return arrTags.map(tag => {
      if(tag)
      return (<span>{tag}</span>)
    });
  }

  render() {
    // console.log('this.state.episode ', this.props)
    const {episodes,linkedWebsite} = this.props.data;
    console.log("CHANNELS",this.props)
    let channelConfig = {};
    if(
      linkedWebsite && 
      linkedWebsite.channels_with_configs &&
      linkedWebsite.channels_with_configs.data
    ){
      linkedWebsite.channels_with_configs.data.map(channelsConfigs => {
        if(channelsConfigs.channel.codename == episodes.data[0].channel.codename){
          channelConfig = channelsConfigs
          if(channelConfig.text_color == "#ffffff")
          channelConfig.text_color = linkedWebsite.background_player_color
        }
        if(channelConfig.title_color == "#ffffff")
          channelConfig.title_color = linkedWebsite.background_player_color
      })
    }

    if(episodes && episodes.data && episodes.data[0].title){
      // Title
      document.title = `Istoé - ${episodes.data[0].title}`;
      document.querySelector('meta[name=title]').setAttribute("content", `Istoé - ${episodes.data[0].title}`);
      document.querySelector('meta[property="og:title"]').setAttribute("content", `Istoé - ${episodes.data[0].title}`);
      document.querySelector('meta[property="twitter:title"]').setAttribute("content", `Istoé - ${episodes.data[0].title}`);

      document.querySelector('meta[property="og:image"]').setAttribute("content", episodes.data[0].thumbnail);
      document.querySelector('meta[property="twitter:image"]').setAttribute("content", episodes.data[0].thumbnail);
      document.querySelector('meta[property="og:image:type"]').setAttribute("content", "image/png");
      document.querySelector('meta[property="og:image:width"]').setAttribute("content", "600");
      document.querySelector('meta[property="og:image:height"]').setAttribute("content", "600");
    }
    
    if(this.state.episode && this.state.episode.premium && (!document.userAccount || !document.userAccount.premium) && true == false ){
      sendMessageToUser('Você precisa de uma assinatura para acessar esse conteúdo!')
      return <Redirect to={`/channels/${this.state.episode.channel.codename}`} />
    }
    if(episodes){
    console.log(episodes.data[0].tags)
    }
    console.log("channelConfig", channelConfig)
    return (
        <Layout {...this.props}>
          <div className="channel-episodes-container"
            style={{
              backgroundImage: `url(${episodes&&episodes.data?episodes.data[0].channel.cover:''})`
            }}
          >
          <Container className="episode-page container">

           {!!this.state.episode && (
              <EpisodeContainer>
                <div className="row">
                  {/* <div className="col m5 s12"> */}
                    {/* <img
                      className="episode-image"
                      src={this.state.episode.thumbnail}
                      alt=""
                    /> */}
                    {/* <RecommendedEpisodes className='hide-on-med-and-down'>
                      <strong className="recommended-title center-align">
                        Episódios recomendados
                      </strong>
                      <Query  query={RECOMEND_EPISODE_QUERY} variables={{
                        category_id: this.state.episode.channel.main_category.id,
                        epThumbWidth: 300,
                        epThumbHeight: 300
                      }}>
                        {
                          ({ loading, error, data }) => {
                            if (loading) return <div> {`Loading: ${loading}`} </div>;
                            if (error) {
                            if (error.networkError) {
                                return <div> {`Error: no network`} </div>;
                            }
                            if (error.graphQLErrors) {
                                return <div> {`Error: ${error}`} </div>;
                            }
                            return <div> {`Error: ${error}`} </div>;
                            }
                            // console.log("DATA_RRECOMEND: ",data)
                            if(!!data.recommendedEpisodes){
                              return data.recommendedEpisodes.data.map(
                                episode => ( 
                                  <EpisodeCardComponent showDetails key={`epcardep-${episode.id}`} horizontal episode={episode} />
                                )
                              )
                            } else {
                              return false
                            }
                          }
                        }
                      </Query>
                    </RecommendedEpisodes> */}
                  {/* </div> */}
                  <div className="col-sm-12">
                    {/* <div className="episode-header center-align">
                      <Link
                        to={`/channels/${this.state.episode.channel.codename}`}
                        className="channel-codename"
                      >
                        {this.state.episode.channel.codename}
                        <span
                          className={`channel-flag channel-${this.state.episode.channel.flag}`}
                        ></span>
                      </Link>
                    </div> */}

                    <div className="episode-content">
                      {/* <div className="player-header-mobile">
                        <div className="episode-plays-time-mobile">
                          <div className="plays">
                            <span className="play-count" style={{ color: channelConfig?channelConfig.title_color: "" }}>
                              { this.state.episode.channel.name }
                            </span>
                          </div>
                          <div className="time-mobile">
                            {
                              moment(this.state.episode.publishDate, "X", "pt-BR", true).fromNow()
                              //moment(this.state.episode.publishDate, "X", "pt-BR", true).format('DD [de] MMMM [de] YYYY')
                            }
                          </div>
                        </div>
                        <div className="episode-title-to-description-mobile" style={{
                          color: channelConfig?channelConfig.text_color: ""
                        }}>
                          {this.state.episode.title}
                        </div>
                         <div className="episode-description-mobile">
                          {this.state.episode.channel.owner.profile.name}
                        </div>  
                      </div>*/}
                      <div className="player-header-mobile">
                        <div className="episode-title-to-description-mobile" style={{
                          color: channelConfig?channelConfig.text_color: ""
                        }}>
                          {this.state.episode.title}
                        </div>
                        <div className="episode-plays-time-mobile">
                          <div className="time-mobile">
                            {
                              //moment(this.state.episode.publishDate, "X", "pt-BR", true).fromNow()
                              moment(this.state.episode.publishDate, "X", "pt-BR", true).format('DD [de] MMMM [de] YYYY')
                            }
                          </div>
                        </div>
                        <div className="episode-description-mobile">
                          {/* this.state.episode.channel.owner.profile.name */}
                        </div>
                      </div>
                      <div className="episode-player">
                      <PlayerComponent 
                          key={this.state.episode.id}
                          episode={this.state.episode} 
                          likes_count={this.state.episode.likes} 
                          dislikes_count={this.state.episode.dislikes} 
                          scope='episode'
                          channelConfig={channelConfig}
                        />
                      </div>

                      <div className="episode-title-to-description" style={{ color: channelConfig?channelConfig.text_color: "" }}>
                        {this.state.episode.title}
                      </div>
                      <div className="episode-plays-time">
                        <div className="plays">
                            {/* { this.props.data.episodes.data[0].play_count > 10 && */}
                              {/* <span className="play-count">
                                { this.renderPlayCount(this.state.episode.play_count) }
                              </span> */}
                            {/* } */}
                        </div>
                        <div className="time">
                              <span className="time-ago">
                                {
                                  //moment(this.state.episode.publishDate, "X", "pt-BR", true).fromNow()
                                  moment(this.state.episode.publishDate, "X", "pt-BR", true).format('DD [de] MMMM [de] YYYY')
                                }
                              </span>
                        </div>

                      </div>
                      
                      <div className="episode-description">
                        {/*
                        <h6 className="left-align episode-description_title">
                          {this.state.episode.channel.owner.profile.name}
                        </h6>
                          */}
                        <p style={{ color: channelConfig?channelConfig.text_color: "" }} dangerouslySetInnerHTML={{__html: this.state.episode.description }}/>
                      </div>

                      {/* <div className="lista-tags">
                        { this.listTags(this.state.episode.tags)}
                      </div> */}
                      {/* <div className="comentarios">
                          COMENTÁRIOS {this.state.episode.block_comments ? "DESABILITADOS": `(${this.state.qtdComentarios})`}
                          {
                          // <div className="em-resposta">
                          //   <img src={this.props.data.episodes.data[0].channel.owner.profile.profilePicture} />
                          //</div>
                          }

                        {
                          (
                            this.state.episode.block_comments || 
                            !localStorage.getItem(ACCESS_TOKEN) || 
                            (
                              this.state.episode.premium && 
                              !JSON.parse(localStorage.getItem(USER_ACCOUNT)).subscribed
                            )
                          ) ?
                          <div></div>
                        :
                          <>
                            <div className="comment-box">
                              <Textarea
                                style={{ background: "#f7f7f5", border: "0px", color: "#666666", fontSize: "12px", fontWeight: "normal"}}
                                minRows={5}
                                maxRows={8}
                                placeholder="Escreva aqui seu comentário..."
                                value={this.state.comentario}
                                onChange={e => this.setState({ comentario: e.target.value })}
                              />
                            </div>
                            <div>
                              <Button
                                  type="submit"
                                  className="auth-button"
                                  onClick={() => {     
                                    let comentario = {episode_id: this.state.episode.id, text: this.state.comentario}
                                    let that = this;
                                    this.props.mutate({variables: comentario})
                                    .then(({data}) => {
                                      // console.log("comentario: ", data)
                                      let oComentario = data.createComment;
                                      that.setState({
                                        comentario: '',
                                        comentarios: that.state.comentarios.unshift(oComentario),
                                        qtdComentarios: that.state.qtdComentarios + 1
                                      })
                                      sendMessageToUser("Comentário criado com sucesso!");
                                    })
                                    .catch((error) => {
                                      sendMessageToUser('É necessário ter um email verificado para poder comentar. Faça isso em "Minha Conta" e comece a interagir agora mesmo!');
                                    });
                                }}
                              >
                                    Comentar
                              </Button> 
                            </div>
                          </>
                        }
                        { !this.state.episode.block_comments &&
                          <div className="lista-comentarios">
                            {this.state.comentarios.map(comentario => (
                              <Comment key={comentario.id} commentClass={comentario}/>
                            ))}
                          </div>
                        }
                      </div> */}
                    </div>
                  </div>
                </div>
              </EpisodeContainer>
            )}
          </Container>
          </div>
        </Layout>
      
    );
  }
}
const propsToOptions = (props) => {
  
  return ({ 
      variables: 
        { 
         epThumbWidth: 600,
         epThumbHeight: 600,
         episode_id: parseInt(props.match.params.id), 
        }
    }
  )
}

export default compose(graphql(EPISODE_QUERY, { options: propsToOptions }),graphql(COMMENT_MUTATION))(Episode);
